/* eslint-disable import/prefer-default-export */
import { useSearchParams } from "react-router-dom";

/**
 * Get the URL query parameters
 * @returns {Function} A function that returns the URL query parameters
 */
export function useUrlQuery() {
	const [searchParams, setSearchParams] = useSearchParams();

	const getSearchParams = () => {
		let params = {};
		searchParams.forEach((value, key) => {
			params[key] = value;
		});
		return params;
	};

	return getSearchParams;
}
